import React from 'react'
import { history } from '../store'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { fetchModules, fetchModuleDownloadCSV, fetchSNDownloadExcel } from '../actions/modules'
import { fetchMachines } from '../actions/machines'
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input } from 'reactstrap';

import Box from '../components/Box'
import classnames from 'classnames';
import PropertyLabel from '../components/PropertyLabel'
import AssignedModuleList from '../components/AssignedModuleList'
import LoadingProgress from '../components/LoadingProgress'

import ModuleList from '../components/ModuleList'
import ModuleErrorList from '../components/ModuleErrorList'
import ErrorMessage from '../components/ErrorMessage'

import '../styles/ModulesView.css'


class ModulesView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      activeTab: this.props.type === 'PRODUCCION' ? '2' : '1',
      searchModalOpen: false,
      searchQuery: '',
      loading: false
    }

    this.handleModuleDownloadCSV = this.handleModuleDownloadCSV.bind(this);
    this.handleSNDownloadExcel = this.handleSNDownloadExcel.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
  }

  componentDidMount() {
    this.props.fetchModules()
    this.props.fetchMachines()
  }

  goTo(Code, e) {
    history.push(`/modules/${Code}`)
  }

  toggleSearchModal = () => {
    this.setState(prevState => ({ searchModalOpen: !prevState.searchModalOpen, searchQuery: '' }));
  }

  handleSearchChange = (e) => {
    this.setState({ searchQuery: e.target.value });
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  printDuplicatedSN() {
    const { modules, machines } = this.props;

    if (!modules || !machines) {
      return <LoadingProgress />
    }

    // Create an object to store the counts of each SN
    const snCounts = {};

    // Iterate through machines and then through each module
    machines.forEach((machine) => {

      if (machine.Serial !== "VLK00000" && machine.Serial !== "VLK00001" && machine.Serial !== "SHOWROOM-O" && machine.Serial !== "SHOWROOM-I") {

        let index = 0;

        machine.Modules.forEach((mod) => {
          // Find the corresponding module in 'modules' that fits mod.Code
          const correspondingModule = modules.find(module => module.Code === mod.serialNumber);

          if (correspondingModule) {

            // Iterate through RegisterLockers of the corresponding module
            correspondingModule.RegisterLockers.forEach((lock) => {
              const { SN } = lock;

              if (!/^0+$/.test(SN)) {
                if (snCounts[SN]) {
                  snCounts[SN].count += 1;
                  snCounts[SN].module.push(mod.serialNumber);
                  snCounts[SN].machine.push(machine.Serial);
                  snCounts[SN].position.push(`${machine.FirstIndex + index}`);
                } else {
                  snCounts[SN] = {
                    count: 1,
                    module: [mod.serialNumber],
                    machine: [machine.Serial],
                    position: [`${machine.FirstIndex + index}`],
                  };
                }
              }

              index++;
            });
          }
        });
      }
    });

    // Find the maximum number of modules for a single SN
    const maxModules = Object.values(snCounts).reduce((max, item) => Math.max(max, item.module.length), 0);

    // Filter the SNs that have duplicates
    const duplicates = Object.entries(snCounts).filter(([SN, data]) => data.count > 1);

    return (
      <div className="table-responsive">
        {duplicates.length > 0 ? (
          <table className="table table-hover table-clickable">
            <thead className="thead-dark">
              <tr>
                <th>DUPLICATED SN</th>
                {[...Array(maxModules)].map((_, index) => <th key={index} colSpan="3">Module {index + 1}</th>)}
              </tr>
            </thead>
            <tbody>
              {duplicates.map(([SN, data]) => (
                <tr key={SN}>
                  <td>{SN}</td>
                  {[...Array(maxModules)].flatMap((_, index) => [
                    <td style={{ borderLeft: '2px solid #067ddb' }} key={index}>Index: {data.position[index] || ''}</td>,
                    <td key={index}>Kiosk: {data.machine[index] || ''}</td>,
                    <td style={{ borderRight: '2px solid #067ddb' }} key={index}>Module: {data.module[index] || ''}</td>
                  ])}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No duplicate SNs found. Aleluyah equipo, por fin lo hemos conseguido! Aaaaaaaaaveee Maaariiiiiiiiaaaaaaa, pleeeenaaaa de graaaciaaaaa esttt...</p>
        )}
      </div>
    );
  }

  printModulesByCustomer() {

    const { machines, modules } = this.props;

    if (!machines || !modules) {
      return <LoadingProgress />
    }

    // Group modules by customer and calculate totals
    const modulesByCustomer = {};
    machines.forEach(machine => {
      const customerName = machine.Customer?.Fullname || 'None';

      if (!modulesByCustomer[customerName]) {
        modulesByCustomer[customerName] = {
          modules: [],
          totals: {} // Track totals for each module type
        };
      }

      // Concatenate modules for each machine
      modulesByCustomer[customerName].modules = modulesByCustomer[customerName].modules.concat(machine.Modules);

      // Count module types
      machine.Modules.forEach(module => {
        const moduleType = module.serialNumber?.substring(0, 5) || 'NONE'; // Assuming the module type is the first 5 characters
        modulesByCustomer[customerName].totals[moduleType] = (modulesByCustomer[customerName].totals[moduleType] || 0) + 1;
      });
    });

    // Render the table for each customer
    return (
      <div>
        {Object.keys(modulesByCustomer).sort().map(customerName => (
          <div key={customerName} className="row mb-2">
            <div className="col-xs-12 col-sm-6 col-md-6">
              <div className="table-responsive">
                <table className="table table-sm table-stripped table-hover table-clickable">
                  <thead className="thead-dark">
                    <tr>
                      <th scope="col">{customerName}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {modulesByCustomer[customerName].modules.map(module => (
                      <tr key={module.serialNumber}
                        onClick={e => this.goTo(module.serialNumber, e)}>
                        <th scope="row">{module.serialNumber}</th>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6">
              <div className="table-responsive">
                <table className="table table-sm table-stripped">
                  <thead className="thead-dark">
                    <tr>
                      <th scope="col">Module Totals {customerName}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.entries(modulesByCustomer[customerName].totals).map(([moduleType, count]) => (
                      <tr>
                        <th scope="row">{`${moduleType}: ${count} unit${count !== 1 ? 's' : ''}`}</th>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  handleModuleDownloadCSV() {
    const { fetchModuleDownloadCSV } = this.props

    this.setState({ loading: true });

    fetchModuleDownloadCSV()
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  handleSNDownloadExcel() {
    const { fetchSNDownloadExcel } = this.props

    this.setState({ loading: true });

    fetchSNDownloadExcel()
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  render() {
    const { role, type, modules, error, machines } = this.props

    if (error) {
      return (<ErrorMessage message={error.message} />)
    }

    if (!modules || !machines) {
      return <LoadingProgress />
    }

    const countByPrefix = (prefix) => modules.filter(m => m.Code.substring(0, 5) === prefix).length

    const countErrors = modules.filter(m => m.Code.substring(0, 3) !== 'VLM' && m.Code.substring(0, 3) !== 'VLK').length

    const countDuplicatedSN = () => {
      const snCounts = {}
      machines.forEach(machine => {
        if (machine.Serial !== 'VLK00000' && machine.Serial !== 'VLK00001' && machine.Serial !== 'SHOWROOM-O' && machine.Serial !== 'SHOWROOM-I') {
          machine.Modules.forEach(mod => {
            const correspondingModule = modules.find(m => m.Code === mod.serialNumber)
            if (correspondingModule) {
              correspondingModule.RegisterLockers.forEach(lock => {
                const { SN } = lock
                if (!/^0+$/.test(SN)) {
                  snCounts[SN] = (snCounts[SN] || 0) + 1
                }
              })
            }
          })
        }
      })
      return Object.values(snCounts).filter(c => c > 1).length
    }

    const tabs = [
      ...(role === 'ADMIN' && type !== 'PRODUCCION' ? [{ id: '1', label: 'Por Cliente', count: null }] : []),
      { id: '2',  label: 'VLK04', count: countByPrefix('VLK04') },
      { id: '3',  label: 'VLK06', count: countByPrefix('VLK06') },
      { id: '13', label: 'VLK08', count: countByPrefix('VLK08') },
      { id: '12', label: 'VLM01', count: countByPrefix('VLM01') },
      { id: '4',  label: 'VLM02', count: countByPrefix('VLM02') },
      { id: '5',  label: 'VLM04', count: countByPrefix('VLM04') },
      { id: '6',  label: 'VLM06', count: countByPrefix('VLM06') },
      { id: '7',  label: 'VLM08', count: countByPrefix('VLM08') },
      { id: '8',  label: 'VLM10', count: countByPrefix('VLM10') },
      { id: '9',  label: 'VLM12', count: countByPrefix('VLM12') },
      { id: '10', label: 'Error', count: countErrors },
      ...(role === 'ADMIN' && type !== 'PRODUCCION' ? [{ id: '11', label: 'SN Duplicados', count: countDuplicatedSN() }] : []),
    ]

    return (
      <div className="modules-view">

        {/* ── Header ───────────────────────────────── */}
        <div className="mach-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-th-large mr-3"></i>
                <span className="text-vw-dark mr-1">Parque de</span>
                <span className="text-vw-light">Módulos</span>
              </h1>
            </div>
            {(role === 'ADMIN' && (type === 'MASTER' || type === 'PROVEEDOR' || type === 'PRODUCCION')) && (
              <div className="header-actions">
                {this.state.loading ? (
                  <div className="loading-wheel"></div>
                ) : (
                  <>
                    <button className="mach-admin-btn secondary" onClick={this.toggleSearchModal}>
                      <i className="fas fa-search"></i>
                      <span>Buscar</span>
                    </button>
                    <button className="mach-admin-btn success" onClick={this.handleModuleDownloadCSV}>
                      <i className="fas fa-file-excel"></i>
                      <span>Módulos CSV</span>
                    </button>
                    <button className="mach-admin-btn warning" onClick={this.handleSNDownloadExcel}>
                      <i className="fas fa-file-excel"></i>
                      <span>SN Excel</span>
                    </button>
                    <Link to="/modules/add" className="mach-admin-btn primary" style={{ color: 'white' }}>
                      <i className="fas fa-plus"></i>
                      <span>Nuevo</span>
                    </Link>
                  </>
                )}
              </div>
            )}
          </div>
        </div>

        {/* ── Tab card ─────────────────────────────── */}
        <div className="modules-tab-card">
          <div className="modules-tab-strip">
            {tabs.map(tab => (
              <button
                key={tab.id}
                className={`modules-tab-btn${this.state.activeTab === tab.id ? ' active' : ''}`}
                onClick={() => this.toggle(tab.id)}
              >
                {tab.label}
                {tab.count !== null && (
                  <span className="modules-tab-badge">{tab.count}</span>
                )}
              </button>
            ))}
          </div>

          <div className="modules-tab-body">
            {this.state.activeTab === '1'  && this.printModulesByCustomer()}
            {this.state.activeTab === '2'  && <ModuleList modules={modules} prefix='VLK04' />}
            {this.state.activeTab === '3'  && <ModuleList modules={modules} prefix='VLK06' />}
            {this.state.activeTab === '13' && <ModuleList modules={modules} prefix='VLK08' />}
            {this.state.activeTab === '12' && <ModuleList modules={modules} prefix='VLM01' />}
            {this.state.activeTab === '4'  && <ModuleList modules={modules} prefix='VLM02' />}
            {this.state.activeTab === '5'  && <ModuleList modules={modules} prefix='VLM04' />}
            {this.state.activeTab === '6'  && <ModuleList modules={modules} prefix='VLM06' />}
            {this.state.activeTab === '7'  && <ModuleList modules={modules} prefix='VLM08' />}
            {this.state.activeTab === '8'  && <ModuleList modules={modules} prefix='VLM10' />}
            {this.state.activeTab === '9'  && <ModuleList modules={modules} prefix='VLM12' />}
            {this.state.activeTab === '10' && <ModuleErrorList modules={modules} />}
            {this.state.activeTab === '11' && this.printDuplicatedSN()}
          </div>
        </div>

        {/* ── Search modal ─────────────────────────── */}
        <Modal isOpen={this.state.searchModalOpen} toggle={this.toggleSearchModal}>
          <ModalHeader toggle={this.toggleSearchModal}>Buscar Módulo por Código</ModalHeader>
          <ModalBody>
            {this.state.searchModalOpen && (
              <>
                <Input
                  type="text"
                  placeholder="Ingrese el código..."
                  value={this.state.searchQuery}
                  onChange={this.handleSearchChange}
                />
                <hr />
                <div className="table-responsive" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                  <table className="table table-hover">
                    <thead>
                      <tr><th>Código</th></tr>
                    </thead>
                    <tbody>
                      {this.props.modules
                        .filter(mod => mod.Code.toLowerCase().includes(this.state.searchQuery.toLowerCase()))
                        .map(mod => (
                          <tr
                            key={mod.Code}
                            onClick={() => { this.goTo(mod.Code); this.toggleSearchModal(); }}
                            style={{ cursor: 'pointer' }}
                          >
                            <td>{mod.Code}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleSearchModal}>Cerrar</Button>
          </ModalFooter>
        </Modal>

      </div>
    )
  }
}

const mapStateToProps = state => ({
  modules: state.modules.modules,
  machines: state.machines.machines,
  error: state.modules.error,
  role: state.auth.role,
  type: state.auth.type
})

const mapDispatchToProps = dispatch => ({
  fetchModules: bindActionCreators(fetchModules, dispatch),
  fetchMachines: bindActionCreators(fetchMachines, dispatch),
  fetchModuleDownloadCSV: bindActionCreators(fetchModuleDownloadCSV, dispatch),
  fetchSNDownloadExcel: bindActionCreators(fetchSNDownloadExcel, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(ModulesView)
